import { render, staticRenderFns } from "./taoBaoOrder.vue?vue&type=template&id=0f48ca0a&scoped=true&"
import script from "./taoBaoOrder.vue?vue&type=script&lang=js&"
export * from "./taoBaoOrder.vue?vue&type=script&lang=js&"
import style0 from "./taoBaoOrder.vue?vue&type=style&index=0&id=0f48ca0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48ca0a",
  null
  
)

export default component.exports